import React from 'react';
import { motion } from 'framer-motion/dist/framer-motion';
import { LoaderIcon } from '../../../react/eagerlyIcons/src/__generated__/icons';

const FormSubmitButton = ({ status, data, onClickHandler }) => {
  return (
    <motion.button className="btn" disabled={status === 'PENDING'} onClick={onClickHandler} layout="position" type="submit" title={data.submitText}>
      {/* {status === 'PENDING' && <LoaderIcon className="loader-icon" />} */}
      {status === 'PENDING' ? data.message.pending : data.submitText}
    </motion.button>
  );
};

export default FormSubmitButton;
